import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

const AlarmsView: React.FC = () => {
    return (
        <Container fluid className="h-100 d-flex align-items-center justify-content-center">
            <Row>
                <Col className="text-center text-muted">
                    <FontAwesomeIcon icon={faBell} size="4x" className="mb-3" />
                    <h3>Alarms</h3>
                    <p>Alarms functionality coming soon...</p>
                </Col>
            </Row>
        </Container>
    );
};

export default AlarmsView;
